export default function Footer() {
  return (
    <footer
      id="contact"
      className="relative border-t border-white/10"
      data-testid="footer"
    >
      <div className="px-[6vw] pb-10 pt-24">
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-amber md:text-xs">
          Contact
        </p>
        <h2 className="mt-6 font-display text-[13vw] font-black uppercase leading-[0.85] tracking-tighter md:text-[9vw]">
          OA Holding
        </h2>

        <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-8">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">
              Head Office
            </p>
            <address
              className="mt-4 text-sm not-italic leading-relaxed text-bone/80"
              data-testid="footer-address"
            >
              OA Holding CO LTD.
              <br />
              Trust Company Complex
              <br />
              Ajeltake Road, Ajeltake Island
              <br />
              Majuro, Marshall Islands MH 96960
              <br />
              P.O. Box 1405
            </address>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">
              Email
            </p>
            <a
              href="mailto:info@oaholding.co"
              className="mt-4 inline-block text-lg text-bone transition-colors duration-300 hover:text-amber"
              data-testid="footer-email"
            >
              info@oaholding.co
            </a>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">
              Company
            </p>
            <p className="mt-4 text-sm leading-relaxed text-bone/80">
              Global shipping &amp; software solutions.
              <br />
              Operating since 1999.
            </p>
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-3 border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-smoke md:flex-row md:items-center md:justify-between">
          <span data-testid="footer-copyright">© 2026 OA Holding CO LTD.</span>
          <span>Majuro — Worldwide</span>
        </div>
      </div>
    </footer>
  );
}
